import { authHeader } from '../../_helpers';
import axios from 'axios';

export const adminOrgService = {
    getOrgAdminList
};
axios.defaults.headers.common = authHeader();

function getOrgAdminList(id, org) {
    return axios.get(`/users/organisation/admin/list/${id}/${org}/`)
        .then(response => {
            return response;
        });
}


// WEBPACK FOOTER //
// ./src/_services/organisation/adminList.service.js